export const HERO_BG =
  "https://images.unsplash.com/photo-1574848296471-28f79a036f79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBtb2Rlcm4lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg2NzUxMzcxfDA&ixlib=rb-4.1.0&q=85&w=2000&auto=format&fit=crop";

export const OFFICE_IMG =
  "https://images.unsplash.com/photo-1559136555-9303baea8ebd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop";

export const MEETING_IMG =
  "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?q=85&w=1200&auto=format&fit=crop";

export const STATS = [
  { value: 99, suffix: "+", label: "Services" },
  { value: 400, suffix: "+", label: "Cities Covered" },
  { value: 5000, suffix: "+", label: "Satisfied Clients" },
  { value: 50000, suffix: "+", label: "Candidates Placed" },
];

export const SERVICES = [
  {
    num: "01",
    icon: "Users",
    title: "Recruitment & Staffing",
    desc: "AI-driven precision hiring from freshers to leadership. Most roles closed within 2 weeks across 400+ cities.",
    tags: ["Permanent Hiring", "Bulk Staffing", "Executive Search"],
    span: "md:col-span-8",
  },
  {
    num: "02",
    icon: "Briefcase",
    title: "HR Consultancy",
    desc: "Policy design, employee development, payroll and performance frameworks tailored to your growth stage.",
    tags: ["HR Audits", "Payroll", "L&D"],
    span: "md:col-span-4",
  },
  {
    num: "03",
    icon: "Building2",
    title: "Business Registration",
    desc: "Private & Public Limited, LLP, Nidhi — registered right, from day one, with zero paperwork stress.",
    tags: ["Pvt Ltd", "LLP", "Nidhi"],
    span: "md:col-span-4",
  },
  {
    num: "04",
    icon: "ShieldCheck",
    title: "Food & Safety Compliance",
    desc: "FSSAI licensing and end-to-end safety compliance for food businesses, restaurants and manufacturers.",
    tags: ["FSSAI", "Audits"],
    span: "md:col-span-4",
  },
  {
    num: "05",
    icon: "Calculator",
    title: "Tax & Compliance",
    desc: "PAN, TAN, GST and TDS filings handled on schedule, so your business stays compliant year-round.",
    tags: ["GST", "TDS", "ITR"],
    span: "md:col-span-4",
  },
  {
    num: "06",
    icon: "Rocket",
    title: "Startup India Support",
    desc: "Complete Startup India & Standup India registration — unlock government benefits, funding and tax holidays.",
    tags: ["DPIIT", "Funding", "Benefits"],
    span: "md:col-span-8",
  },
];

export const INDUSTRIES = [
  "IT & SaaS",
  "BFSI",
  "Healthcare & Pharma",
  "Manufacturing",
  "Retail & E-commerce",
  "Food & Hospitality",
  "EdTech",
  "Startups",
  "Logistics",
  "Real Estate",
];

export const FAQS = [
  {
    q: "What services do you offer at HR99 Global Services?",
    a: "We provide a wide range of services to support your business — from company registration and taxation to compliance, HR solutions, intellectual property protection, and much more. Whatever your business needs, we've got you covered.",
  },
  {
    q: "How fast can you help fill a job vacancy?",
    a: "We specialize in quickly filling vacancies and can typically close roles within just 2 weeks. Our team makes the hiring process smooth and fast so you don't have to wait long for the right talent.",
  },
  {
    q: "Do you assist with registering startups?",
    a: "Yes, we offer complete support for startups, including Startup India and Standup India registrations. We'll help you navigate the process and ensure you take full advantage of the government benefits available to new businesses.",
  },
  {
    q: "What types of businesses can you help register?",
    a: "We can help you register various types of businesses, including Private and Public Limited Companies, LLPs, Nidhi Companies, and more. We make sure everything is set up correctly from the start.",
  },
  {
    q: "Can you handle my business's tax filings and compliance?",
    a: "Absolutely! We provide a full suite of tax services, including PAN, TAN, GST, and TDS filings, to ensure your business stays compliant with tax regulations. We'll keep everything on track so you don't have to worry.",
  },
];

export const JOBS = [
  { title: "Tele Collection Executive", location: "Jaipur", type: "Full-time" },
  { title: "Corporate Travel Coordinator", location: "Delhi", type: "Full-time" },
  { title: "Company Secretary", location: "Jaipur", type: "Full-time" },
  { title: "HR Trainee", location: "Remote", type: "Internship" },
  { title: "Accounts Executive (Tally / GST)", location: "Delhi", type: "Full-time" },
];

export const INQUIRY_TYPES = [
  "Recruitment / Staffing",
  "HR Consultancy",
  "Business Registration",
  "Compliance & Taxation",
  "Job Seeker / Career",
  "Other",
];

export const SOCIALS = [
  {
    key: "whatsapp-channel",
    label: "WhatsApp Channel",
    url: "https://whatsapp.com/channel/0029VaoQeTMIt5s1noXyjW3L",
    icon: "whatsapp",
  },
  {
    key: "instagram",
    label: "Instagram",
    url: "https://www.instagram.com/hr99global/profilecard/?igsh=cWdocTR3Ymk2eXhp",
    icon: "instagram",
  },
  {
    key: "linkedin",
    label: "LinkedIn",
    url: "https://www.linkedin.com/company/hr99-global/",
    icon: "linkedin",
  },
  {
    key: "facebook",
    label: "Facebook",
    url: "https://www.facebook.com/share/14cpKzi9Pgt/",
    icon: "facebook",
  },
];
